















































import { SocialInquiryModel, UnitOfMeasureModel } from '@/libs/Api';
import Page from '@/Page.vue';
import { Guid } from '@/libs/common/functions/guid';
import { Component, Prop, Ref, Watch } from 'vue-property-decorator';
import { socialInquiriesStore } from '@/libs/social-inquiries/+state/store';
import { CrudAction, CrudReponse } from '@/libs/core/+state/models/crud-action';
import { createCrudQueryPayload } from '@/libs/core/+state/models/crud-query-payload';

@Component({})
export default class SocialInquiryDialog extends Page {

    dialog = false;
    valid = true;
    saving = false;
    item: SocialInquiryModel | null = null;
    priceSuffix = "";
    deleteDialog = false;
    deleting = false;
    basicRules = [
        (v: any) => !!v || this.$t('validation.thisFieldIsRequired')
    ];

    get isNewItem() : boolean {
        return this.item?.id == Guid.EmptyGuid();
    }

    @Watch("dialog")
    dialogChanged(v: boolean) {
        if (!v)
            this.close();
    }

    @Ref() form!: any;
    @Prop() position!: number;

    load(id: string | null) {
        if (id == null || id == Guid.EmptyGuid()) {
            this.item = {
                id: Guid.EmptyGuid(),
                name: "",
                position: 1,
                isActive: true
            } as SocialInquiryModel;
        }
        else {
            socialInquiriesStore.dispatch(CrudAction.Get, { id: id });
            this.subscribe(socialInquiriesStore, CrudReponse.Get).then((e: SocialInquiryModel) => {
                this.item = e;
            });
        }
    }

    open (id: string | null = null) {
        this.dialog = true;
        this.load(id);
    }

    close () {
        this.dialog = false;
    }

    save () {
        if (this.form.validate()) {
            this.saving = true;
            if (this.item!.id == Guid.EmptyGuid()) {
                this.item!.position = this.position;
                socialInquiriesStore.dispatch(CrudAction.Create, { item: this.item });
                this.subscribe(socialInquiriesStore, CrudReponse.Create).then((e: SocialInquiryModel) => {
                    this.saving = false;
                    this.close();
                }).catch((e: any) => {
                    this.saving = false;
                });
            }
            else {
                socialInquiriesStore.dispatch(CrudAction.Update, { item: this.item });
                this.subscribe(socialInquiriesStore, CrudReponse.Update).then((e: SocialInquiryModel) => {
                    this.saving = false;
                    this.close();
                }).catch((e: any) => {
                    this.saving = false;
                });
            }
        }
    }

    deleteClick () {
        this.deleteDialog = true;
    }

    deleteItem () {
        this.deleting = true;
        socialInquiriesStore.dispatch(CrudAction.Delete, { id: this.item?.id });
        this.subscribe(socialInquiriesStore, CrudReponse.Delete).then((e: SocialInquiryModel) => {
            this.deleting = false;
            this.deleteDialog = false;
            this.close();
        }).catch((e: any) => {
            this.deleting = false;
        });
    }

}
